import { fakeI18n } from "@/i18n";
import { SearchContext } from "@/shared/apis/searchApi";
import { Permissions } from "@/shared/domain";
import { Identity } from "@/shared/domain/identity";

export const getFilters = (user: Identity, policyholders: number[]) => {
    return [
        {
            id: SearchContext.All,
            label: fakeI18n.t("Common.All"),
        },
        ...(user.someHasPermission(Permissions.ViewInformation, policyholders)
            ? [
                  {
                      id: SearchContext.Party,
                      label: fakeI18n.t("PolicyHolders.PolicyHolders"),
                  },
              ]
            : []),
        ...(user.someHasPermission(Permissions.ViewContracts, policyholders)
            ? [
                  {
                      id: SearchContext.Contract,
                      label: fakeI18n.t("Common.Contracts"),
                  },
              ]
            : []),
        ...(user.someHasPermission(Permissions.ViewRisks, policyholders)
            ? [
                  {
                      id: SearchContext.RiskObject,
                      label: fakeI18n.t("Breadcrumbs.InsuredGoods"),
                  },
              ]
            : []),
        ...(user.someHasPermission(Permissions.ViewClaims, policyholders)
            ? [
                  {
                      id: SearchContext.Claim,
                      label: fakeI18n.t("Common.Claims"),
                  },
              ]
            : []),
    ];
};
